"use strict";
/*
* {
    broadcaster: 'pusher',
    cluster: process.env.NEXT_PUBLIC_PUSHER_CLUSTER,
    forceTLS: true,
    withoutInterceptors: true,
    key: process.env.NEXT_PUBLIC_PUSHER_KEY,
    authEndpoint: '/api/broadcasting/auth',
  },
* */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEchoConfig = void 0;
const getEchoConfig = (echoProps) => ({
    // THE ROUTE FOR AUTH BROADCASTING NEEDS TO NOT REQUIRE CSRF VERIFICATION.
    // const xsrfTokenCookie = await getXsrfToken()
    //
    // echoProps.auth = echoProps.auth || {}
    //
    // echoProps.auth.headers = {
    //   ...(echoProps.auth.headers || {}),
    //   'X-XSRF-TOKEN': xsrfTokenCookie,
    // }
    echoProps: () => __awaiter(void 0, void 0, void 0, function* () { return echoProps; }),
});
exports.getEchoConfig = getEchoConfig;
